import React, { Component } from 'react';

import commonUtil from '../../../utils/commonUtil';
import { storeIcon } from './svgIcons';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
class StoreLocationBtn extends Component {
  state = { hasError: '', error: '', info: '', hoverState: false };

  componentDidCatch(error, info) {
    this.setState({ hasError: '', error, info });
  }

  setHoverState = active => this.setState({ ...this.state, hoverState: active })

  render() {
    const {
      showModalLocationContentUpdate,
      storeNearSelected = 'error',
      className,
    } = this.props;

    const { hasError, hoverState } = this.state;

    try {
      this.hasLocalStorage = localStorage.getItem('favoriteStoreName');
    } catch (error) {
      this.hasLocalStorage = '';
    }

    return (
      <section
        className={className || ''}
        style={{ position: 'relative' }}
        onMouseEnter={() => this.setHoverState(true)}
        onMouseLeave={() => this.setHoverState(false)}
      >
        <div className="itemLink">
          {storeIcon}
          <a
            className="item"
            onClick={showModalLocationContentUpdate}
          >
            {this.hasLocalStorage ? 'Mi tienda' : 'Elige una tienda'}
          </a>
          {(!this.hasLocalStorage && hoverState) && (<span className="decoratorUndeline" />)}
        </div>

        <div className="itemLink">
          <a
            className={`item regularFont ${channel === constChannels.WAP ? 'ellipsisStoreLocation' : ''}`}
            onClick={showModalLocationContentUpdate}
          >
            { !!hasError || storeNearSelected || this.hasLocalStorage }
          </a>
        </div>

        {(this.hasLocalStorage && hoverState) && (<span className="decoratorUndeline undelineHoverStoreLoc" />)}
      </section>
    );
  }
}

export default StoreLocationBtn;
